export const facebook = "/media/icons/fb.png";
export const google = "/media/icons/google.png";
export const basket = "/media/icons/trolley.svg";
export const location = "/media/icons/location.svg";
export const downArrow = "/media/icons/downArrow.svg";
export const clock = "/media/icons/clock.svg";
export const plus = "/media/icons/plus.svg";
export const email = "/media/icons/email.svg";
export const shop = "/media/icons/shop.svg";
export const noShop = "/media/icons/shop_strikethrough.svg";
export const user = "/media/icons/user.svg";
export const delivery = "/media/icons/car.svg";
export const collection = "/media/icons/bag.svg";
export const phone = "/media/icons/phone.svg";

export const visible = "/media/icons/eye.svg";
export const hidden = "/media/icons/eye_strikethrough.svg";

export const reduce = "/media/icons/minus_2.svg";
export const add = "/media/icons/plus_2.svg";
export const edit = "/media/icons/pencil.svg";
export const remove = "/media/icons/bin.svg";
export const reset = "/media/icons/undo.svg"; 
export const save = "/media/icons/save.svg";

export const cross = "/media/icons/cross.svg";
export const picture = "/media/icons/image.svg";
export const picturePlaceholder = "/media/icons/image_placeholder.svg";
export const info = "/media/icons/info.svg";